<template>
  <main class="main">
      <organization_header :dropshipping="true" v-if="$store.getters.getCompany.dropshipping"/>
      <div class="table">
        <loading-container :loading="loading" >
        <table >
          <tr>
            <th>Закупщик</th>
            <th>Тарифный план</th>
          </tr>
          <tr v-for="(item, idx) in purchasers" :key="idx + key">
            <td>
                <router-link class="links_color" :to="'/profile/' + item.company.id + '?drop=1'" target="_blank">
                    {{item.company.name}}
                </router-link>
            </td>
            <td>
                <app-select :options="segments" @input="selectSegment(item)" v-model="item.segment" label="title" :placeholder="'Тарифный план'"/>
            </td>
          </tr>
        </table>
      </loading-container>
      </div>
      <pagination
          :key="paginat"
          v-show="last_page > 1"
          v-model="page"
          :page-count="last_page"
      />
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import Pagination from "@/components/pagination";
import AppSelect from "@/components/app-select";
import organization_header from "@/components/OrganizationHeader.vue"

export default {
  name: "dropshipping-purchasers",
  components: {
    LoadingContainer,
    Pagination,
    AppSelect,
    organization_header
  },
  data: ()=>({
    last_page: 0,
    paginat: null,
    page: 0,
    loading: true,
    purchasers: null,
    key: 1,
    segments: [
        {title: 'Базовый', type: 1},
        {title: 'Silver', type: 2},
        {title: 'Gold', type: 3},
    ]
  }),
  mounted() {
    this.getPurchasers();
  },
  methods: {
    getPurchasers(){
      this.$http.post('/get-dropshipping-purchasers', {
        token: localStorage.getItem('token'),
        page:this.page
      }).then(({data}) => {
        if (data.purchasers){
          this.purchasers = data.purchasers.data;
          this.last_page = data.purchasers.last_page;
          this.page = data.purchasers.current_page;
          this.loading = false;
          for (const key in this.purchasers) {
              if (this.purchasers[key].commission) {
                  if (this.purchasers[key].commission.type == 1) {
                      this.purchasers[key].segment = {title: 'Базовый', type: 1};
                  }

                  if (this.purchasers[key].commission.type == 2) {
                      this.purchasers[key].segment = {title: 'Silver', type: 2};
                  }

                  if (this.purchasers[key].commission.type == 3) {
                      this.purchasers[key].segment = {title: 'Gold', type: 3};
                  }
              }
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    selectSegment(item) {
     this.$http.post('/set-commission-purchaser', {
       token: localStorage.getItem('token'),
       type: item.segment.type,
       id: item.id
     }).then(({data}) => {
       if (data.success){
         this.key++;
         this.$toast.success('Данные успешно сохранены!');
       }
     }).catch((error) => {
       console.log(error)
     })
    }
  },
  watch: {
    page: function (val) {
      if (val >= 1) {
        this.loading = true;
        this.getPurchasers();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
        vertical-align: middle;
        &.done{
          color: #2cb181;
        }
      }
    }
  }
}


</style>
